<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>履约报表：</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData()"
      >
        刷新
      </el-button>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form
                ref="searchFormRef"
                :inline="true"
                :model="form"
                class="demo-form-inline"
              >
                <el-form-item>
                  <el-input
                    v-model="form.plan_id"
                    placeholder="代采计划单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.supply_id"
                    placeholder="商家ID"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <supply-select @change="changeSupplyId"></supply-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.market_id"
                    placeholder="市场"
                    clearable
                  >
                    <el-option
                      v-for="item in optionsData.options_market"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.arr_city_id"
                    multiple
                    clearable
                    placeholder="请选择城市"
                  >
                    <el-option
                      v-for="item in optionsData.options_supply_city"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.goods_kh"
                    placeholder="款号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.goods_no"
                    placeholder="货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.arr_pg_group_id"
                    filterable="filterable"
                    placeholder="代采组"
                    multiple
                    clearable
                  >
                    <el-option
                      v-for="item in optionsData.options_pg_group"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.arr_pg_member_id"
                    filterable="filterable"
                    placeholder="代采员"
                    multiple
                    clearable
                  >
                    <el-option
                      v-for="item in optionsData.options_pg_member"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.ptype"
                    placeholder="计划生成方式"
                    clearable
                  >
                    <el-option
                      v-for="item in optionsData.options_ptype"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.plan_type"
                    placeholder="代采类型"
                    clearable
                  >
                    <el-option
                      v-for="item in optionsData.options_plan_type"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="需求日期：">
                  <el-date-picker
                    v-model="form.demanded_date"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-checkbox
                    v-model="form.is_only_wait_plan"
                    true-label="1"
                    false-label="2"
                  >
                    只看有待开单
                  </el-checkbox>
                </el-form-item>
                <el-form-item>
                  <el-button type="default" @click="reset">重置</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div class="header">
          <div>
            数据列表
            <span style="color: #4e9fe8">
              （数量/金额，金额按计划代采单统计）
            </span>
          </div>
          <div class="btn-wrap">
            <el-button
              class="button"
              type="success"
              size="mini"
              @click="exportDataExcel(exportType.EXPORT_LIST)"
            >
              导出列表
            </el-button>
            <el-button
              class="button"
              type="success"
              size="mini"
              @click="exportDataExcel(exportType.EXPORT_GOODS_DETAIL)"
            >
              导出商品明细
            </el-button>
          </div>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData.list"
            ref="multipleTable"
            v-loading="loading"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :row-class-name="tableRowClassName"
            show-summary
            :summary-method="summaryResults"
            :max-height="750"
          >
            <el-table-column
              key="str_demanded_date"
              align="center"
              prop="str_demanded_date"
              label="需求日期"
              fixed="left"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="str_supply"
              label="商家"
              show-overflow-tooltip
              fixed="left"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="str_pg_group"
              label="代采组"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              align="center"
              prop="str_pg_member"
              label="代采员"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="24h_performance_rate"
              label="24H履约率"
            >
              <template #header>
                <el-tooltip class="item" effect="dark" placement="top">
                  <div style="position: relative">
                    24H履约率<i class="el-icon-question" />
                  </div>
                  <div slot="content">
                    <div>24H履约率 = 24H已履约金额 / 总需求金额</div>
                    <div>24H：履约时间-需求日期 7:00 ≤ 24H</div>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="48h_performance_rate"
              label="48H履约率"
            >
              <template #header>
                <el-tooltip class="item" effect="dark" placement="top">
                  <div style="position: relative">
                    48H履约率<i class="el-icon-question" />
                  </div>
                  <div slot="content">
                    <div>48H履约率 = 48H已履约金额 / 总需求金额</div>
                    <div>48H：履约时间-需求日期 7:00 ≤ 48H</div>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="final_performance_rate"
              label="最终履约率"
            >
              <template #header>
                <el-tooltip class="item" effect="dark" placement="top">
                  <div style="position: relative">
                    最终履约率<i class="el-icon-question" />
                  </div>
                  <div slot="content">
                    <div>最终履约率 = 最终已履约金额 / 总需求金额</div>
                    <div>春夏（3月~9月）：履约时间 - 需求日期 7:00 ≤ 10天</div>
                    <div>秋冬（10月~2月）：履约时间 - 需求日期 7:00 ≤ 15天</div>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column align="center" label="总需求">
              <el-table-column
                align="center"
                prop="str_all_pre"
                label="前置仓发货"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      前置仓发货<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计前一天6:00至当天6:00由前置仓发货的商品，包含发货出库、售后寄出和前置仓异常出库（即前置仓买赔）
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_all_plan"
                label="订货单计划代采"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      订货单计划代采<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划中，总计划代采的商品数据。不含提前代采计划
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="str_all_sum" label="小计">
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      小计<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      总需求 = 前置仓发货 + 订货单计划代采
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              align="center"
              label="已履约"
              label-class-name="performance"
            >
              <el-table-column
                align="center"
                prop="str_done_pre"
                label="前置仓发货"
                label-class-name="performance"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      前置仓发货<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计前一天6:00至当天6:00由前置仓发货的商品，包含发货出库、售后寄出和前置仓异常出库（即前置仓买赔）
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_done_plan"
                label="订货单正常品已入库（含坏账）"
                label-class-name="performance"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      订货单正常品已入库（含坏账）<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划，开单后售前首次以正常品入库 或
                      首次申请为坏账时计入。
                      ①恢复欠货/正常品入库后调拨为不良品/坏账驳回均不再扣除。
                      ②已计入履约的，不再重复计算。
                      ③履约时间：代采欠货正常品入库-取生成包裹时间；退换货欠货正常品入库
                      -取入库时间；申请坏账 - 申请坏账时间
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_done_sum"
                label="小计"
                label-class-name="performance"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      小计<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      已履约 = 前置仓发货 + 订货单正常品已入库（含坏账）
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              align="center"
              label="待履约"
              label-class-name="await-performance"
            >
              <el-table-column
                align="center"
                prop="str_doing_plan"
                label="待开单"
                label-class-name="await-performance"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      待开单<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划当前在待开单的商品数据。
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_doing_owe"
                label="订单欠货"
                label-class-name="await-performance"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      订单欠货<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划当前在订单欠货（含由订单欠货转退款中）的商品数据。
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_doing_on_way"
                label="配送在途"
                label-class-name="await-performance"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      配送在途<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划当前在配送在途（即在途库存）、在途转欠货申请中的商品数据。
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_doing_reject"
                label="退换货"
                label-class-name="await-performance"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      退换货<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划当前为售前不良品在库、退换货待接收、退换货欠货、由售前退换货转退款中和转呆账的商品数据。
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_doing_sum"
                label="小计"
                label-class-name="await-performance"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      小计<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      待履约 = 待开单 + 订单欠货 + 配送在途 + 退换货
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              align="center"
              label="未履约"
              label-class-name="default"
            >
              <el-table-column
                align="center"
                prop="str_yet_stopped"
                label="已断货"
                label-class-name="default"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      已断货<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划当前已断货的商品数据。
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_yet_ded"
                label="转抵扣"
                label-class-name="default"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      转抵扣<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划当前已转抵扣（含待抵扣、已抵扣、待抵扣转退款中）的商品数据。
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_yet_refund"
                label="已退款"
                label-class-name="default"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      已退款<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划当前已完成退款的商品数据。
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_yet_sum"
                label="小计"
                label-class-name="default"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      小计<i class="el-icon-question" />
                    </div>
                    <div slot="content">未履约 = 已断货 + 转抵扣 + 已退款</div>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="操作" show-overflow-tooltip align="center">
              <template #default="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope.row)"
                >
                  查看详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="form.page"
            :page-size="form.page_size"
            :page-sizes="[10, 20, 30, 50, 100]"
            background
            layout="total, prev, pager, next, jumper,sizes "
            :total="resData.count"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

import supplySelect from "@/components/supplySelect.vue";
import {
  postGetList,
  getOptionsForList,
} from "@/openapi/erp/performanceReport.js";

const initResData = () => ({
  list: [],
  count: 0,
});

const ALL_SUPPLY = "0";

export default {
  components: {
    supplySelect,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchOptions();
    });
  },
  data() {
    return {
      resData: initResData,
      optionsData: {
        pg_list: [],
        owner_option: [],
        options_supply_city: [],
      },
      supply: {
        list: [],
      },
      form: {
        page: 1,
        page_size: 20,
        is_only_wait_plan: "2",
      },
      filterable: true,
      loading: false,
      tableLoading: false,
      url: "/erp/WcgOrder/GetDataOfWcg",
      status: -1,
      curPage: 1,
      filterFold: false,
      isAll: false,
      exportType: {
        EXPORT_LIST: 1,
        EXPORT_GOODS_DETAIL: 2,
      },
    };
  },
  computed: {
    filteredForm() {
      return Object.entries(this.form).reduce((newForm, [key, value]) => {
        if (value !== undefined && value !== "" && value !== null) {
          newForm[key] = value;
        }
        return newForm;
      }, {});
    },
  },

  methods: {
    // 查询
    search() {
      this.form.page = 1;
      this.form.page_size = 20;
      this.fetchData();
    },
    // 重置
    reset() {
      this.$refs.searchFormRef.resetFields();
      this.form = this.$options.data().form;
      this.search();
    },

    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData();
    },
    // 切换页数
    handleSizeChange(val) {
      this.form.page_size = val;
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      const params = {
        ...this.filteredForm,
        supply_id: this.form.supply_id
          ? this.form.supply_id
          : this.form.supply_id_search,
      };
      // 获取履约报表数据
      postGetList(params)
        .then((res) => {
          this.resData = res;
        })
        .catch(() => {
          this.resData = initResData;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 导出列表
    exportDataExcel(exportType) {
      const params = { ...this.filteredForm, export_type: exportType };
      postGetList(params)
        .then((res) => {
          const { file } = res;
          window.open(apiBaseURL + file);
        })
        .catch(this.$noop);
    },

    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;
      return end;
    },
    handleSelect() {},
    pickerChange() {
      this.isAll = false;
    },
    switchChange(val) {
      if (val) {
        delete this.form.create_time;
      }
    },
    tableRowClassName({ row }) {
      if (row.is_pink) {
        return "stock-row";
      }
      return "";
    },

    fetchOptions() {
      getOptionsForList()
        .then((res) => {
          if (Object.keys(res).length > 0) {
            this.optionsData = res;
          }
        })
        .catch(this.$noop);
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleClick(row) {
      console.log("row", row, row.str_demanded_date);
      this.$router.push(
        `/home/purchasing/performanceReportDetail?supply_id=${row.supply_id}&demanded_date=${row.str_demanded_date}`
      );
    },
    changeSupplyId(e) {
      // 全部商家则为空字符串 兼容组件中全部为0的情况
      this.form.supply_id_search = e === ALL_SUPPLY ? "" : e;
    },
    // 数据汇总
    summaryResults(param) {
      const { columns } = param;
      const { sum_of_list: sumOfList } = this.resData;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "查询结果汇总";
          return;
        }
        const { property } = column;
        if (Object.keys(sumOfList).includes(property)) {
          sums[index] = sumOfList[property];
        }
      });
      return sums;
    },
  },
};
</script>

<style scoped>
.header {
  background: #f3f3f3;
  height: 50px;
  line-height: 30px;
  padding: 0 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ .el-table .stock-row {
  background: #fabba7;
}
/deep/ .el-table .el-table__cell.performance {
  background: #aeebcf;
}
/deep/ .el-table .el-table__cell.await-performance {
  background: #bed3fc;
}
/deep/ .el-table .el-table__cell.default {
  background: #f0c98c;
}
</style>



// WEBPACK FOOTER //
// src/pages/PerformanceReport/index.vue